import React from "react";
import { connect } from "react-redux";

import { IAppState } from "../../state/Store";
import { clearThread, subscribe } from "../../state/system/Messaging";
import { addAlert } from "../../state/system/Alerts";
import AlertEntry from "../../types/system/AlertEntry";

interface MessagingToolbarProps {
    broadcasting: boolean;
    allowBroadcast: boolean;
    allowRegister: boolean;
    broadcast: () => void;
    addAlert: (alert: AlertEntry) => void;
    clearThread: () => void;
    subscribe: (createNew: boolean) => void;
    didSubscribe: () => void;
}

class MessagingToolbar extends React.Component<MessagingToolbarProps> {
    async subscribe() {
        await this.props.subscribe(true);

        this.props.didSubscribe();
        this.props.addAlert({
            text: "You are now subscribed for notifications on this device",
        });
    }

    render(): React.ReactNode {
        return (
            <div className="flex-row full spaced vertical-buffer-small message-toolbar">
                {this.props.allowRegister && (
                    <button
                        onClick={() => this.subscribe()}
                        data-tip="Subscribe to notifications">
                        <i>notifications</i>
                    </button>
                )}
                <button
                    onClick={this.props.clearThread}
                    data-tip="Start a new message">
                    <i>add_comment</i>
                </button>
                {this.props.allowBroadcast && (
                    <button
                        className={`${
                            this.props.broadcasting ? "theme" : ""
                        } broadcast-button`}
                        onClick={() => this.props.broadcast()}
                        data-tip="Broadcast a message">
                        <i>campaign</i>
                    </button>
                )}
                <span className="spacer"></span>
                <button
                    className="close-button-tools"
                    ng-click="actions.cancel()"
                    data-tip="Close messaging">
                    <i>close</i>
                </button>
            </div>
        );
    }
}

const mapStateToProps = (state: IAppState) => {
    return {};
};

const mapDispatchToProps = dispatch => {
    return {
        addAlert: (alert: AlertEntry) => dispatch(addAlert(alert)),
        clearThread: () => dispatch(clearThread()),
        subscribe: (createNew: boolean) => dispatch(subscribe(createNew)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(MessagingToolbar);
